(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animated-cards-layout"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const MODULE_KEY = 'TrainingGoalsNativeSliderV7';
    const ROOT_SELECTOR = '[data-training-goals]';
    const states = new WeakMap();
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const desktopQuery = window.matchMedia('(min-width: 990px)');

    function clamp(value, minimum, maximum) {
      return Math.min(Math.max(value, minimum), maximum);
    }

    function getMode(root) {
      if (mobileQuery.matches && root.dataset.mobileLayout === 'slider') {
        return 'mobile';
      }

      if (desktopQuery.matches && root.dataset.desktopSlider === 'true') {
        return 'desktop';
      }

      return null;
    }

    function setButtonState(button, disabled) {
      if (!button) return;

      button.disabled = disabled;
      button.classList.toggle('is-disabled', disabled);
      button.setAttribute('aria-disabled', String(disabled));
    }

    function autoplayIsEnabled(state) {
      if (!state || state.maxIndex < 1) return false;

      if (
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        return false;
      }

      if (state.mode === 'mobile') {
        return state.root.dataset.mobileAutoplay === 'true';
      }

      if (state.mode === 'desktop') {
        return state.root.dataset.desktopAutoplay === 'true';
      }

      return false;
    }

    function stopAutoplay(state) {
      if (!state) return;

      window.clearTimeout(state.autoplayTimer);
      state.autoplayTimer = 0;
    }

    function scheduleAutoplay(state) {
      stopAutoplay(state);

      if (
        !autoplayIsEnabled(state) ||
        state.isInteracting ||
        document.hidden
      ) {
        return;
      }

      const delay = Math.max(
        1000,
        Number.parseInt(state.root.dataset.autoplayDelay || '3500', 10)
      );

      state.autoplayTimer = window.setTimeout(() => {
        if (
          !autoplayIsEnabled(state) ||
          state.isInteracting ||
          document.hidden
        ) {
          scheduleAutoplay(state);
          return;
        }

        const currentIndex = getCurrentIndex(state);
        const nextIndex =
          currentIndex >= state.maxIndex
            ? 0
            : currentIndex + 1;

        scrollToIndex(state, nextIndex, true);
        scheduleAutoplay(state);
      }, delay);
    }

    function getElements(root, mode) {
      const isMobile = mode === 'mobile';

      return {
        viewport: root.querySelector('[data-training-goals-slider]'),
        track: root.querySelector('.training-goals__grid'),
        slides: Array.from(root.querySelectorAll('.training-goals__slide')),
        previous: root.querySelector(
          isMobile
            ? '[data-training-goals-prev]'
            : '[data-training-goals-desktop-prev]'
        ),
        next: root.querySelector(
          isMobile
            ? '[data-training-goals-next]'
            : '[data-training-goals-desktop-next]'
        ),
        pagination: root.querySelector(
          isMobile
            ? '[data-training-goals-pagination]'
            : '[data-training-goals-desktop-pagination]'
        ),
      };
    }

    function clearPagination(state) {
      if (state.pagination) {
        state.pagination.replaceChildren();
      }

      state.paginationButtons = [];
    }

    function renderPagination(state) {
      clearPagination(state);

      if (!state.pagination || state.maxIndex < 1) return;

      const fragment = document.createDocumentFragment();

      for (let index = 0; index <= state.maxIndex; index += 1) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'training-goals__pagination-button';
        button.dataset.sliderIndex = String(index);
        button.setAttribute('aria-label', `Slide ${index + 1}`);
        fragment.appendChild(button);
        state.paginationButtons.push(button);
      }

      state.pagination.appendChild(fragment);
    }

    function getCurrentIndex(state) {
      if (!state.step) return 0;

      return clamp(
        Math.round(state.viewport.scrollLeft / state.step),
        0,
        state.maxIndex
      );
    }

    function updateControls(state) {
      const maximumScroll = Math.max(
        0,
        state.viewport.scrollWidth - state.viewport.clientWidth
      );

      const atStart = state.viewport.scrollLeft <= 2;
      const atEnd = maximumScroll <= 2 || state.viewport.scrollLeft >= maximumScroll - 2;
      const currentIndex = getCurrentIndex(state);

      state.currentIndex = currentIndex;

      setButtonState(state.previous, atStart);
      setButtonState(state.next, atEnd);

      state.paginationButtons.forEach((button, index) => {
        const active = index === currentIndex;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function scrollToIndex(state, requestedIndex, smooth = true) {
      const index = clamp(requestedIndex, 0, state.maxIndex);
      const maximumScroll = Math.max(
        0,
        state.viewport.scrollWidth - state.viewport.clientWidth
      );
      const target = Math.min(index * state.step, maximumScroll);

      state.viewport.scrollTo({
        left: target,
        behavior: smooth ? 'smooth' : 'auto',
      });

      state.currentIndex = index;
    }

    function calculateLayout(state, preserveIndex = true) {
      const previousIndex = preserveIndex ? state.currentIndex || 0 : 0;
      const viewportWidth = state.viewport.clientWidth;

      if (!viewportWidth || !state.slides.length) return;

      const visible =
        state.mode === 'mobile'
          ? Math.max(1, Number.parseFloat(state.root.dataset.mobileSlides || '1.1'))
          : Math.max(1, Number.parseFloat(state.root.dataset.desktopColumns || '4'));

      const gap =
        state.mode === 'mobile'
          ? Math.max(0, Number.parseFloat(state.root.dataset.mobileGap || '16'))
          : Math.max(0, Number.parseFloat(state.root.dataset.desktopGap || '18'));

      const slideWidth = Math.max(
        1,
        (viewportWidth - gap * Math.max(0, visible - 1)) / visible
      );

      state.root.style.setProperty('--tg-native-gap', `${gap}px`);
      state.root.style.setProperty('--tg-native-slide-width', `${slideWidth}px`);
      state.track.style.gap = `${gap}px`;

      state.slides.forEach((slide) => {
        slide.style.width = `${slideWidth}px`;
        slide.style.minWidth = `${slideWidth}px`;
        slide.style.maxWidth = `${slideWidth}px`;
        slide.style.flexBasis = `${slideWidth}px`;
      });

      state.step = slideWidth + gap;

      window.requestAnimationFrame(() => {
        const maximumScroll = Math.max(
          0,
          state.viewport.scrollWidth - state.viewport.clientWidth
        );

        state.maxIndex = Math.max(
          0,
          Math.ceil((maximumScroll - 1) / state.step)
        );

        renderPagination(state);
        scrollToIndex(state, Math.min(previousIndex, state.maxIndex), false);

        window.requestAnimationFrame(() => {
          updateControls(state);
          scheduleAutoplay(state);
        });
      });
    }

    function destroySection(root) {
      const state = states.get(root);

      stopAutoplay(state);

      if (!state) {
        root.classList.remove('is-native-slider-ready');
        root.removeAttribute('data-native-slider-mode');
        return;
      }

      state.cleanup.forEach((callback) => callback());
      state.resizeObserver?.disconnect();
      window.cancelAnimationFrame(state.scrollFrame);
      window.cancelAnimationFrame(state.layoutFrame);

      clearPagination(state);

      state.slides.forEach((slide) => {
        slide.style.removeProperty('width');
        slide.style.removeProperty('min-width');
        slide.style.removeProperty('max-width');
        slide.style.removeProperty('flex-basis');
      });

      state.track.style.removeProperty('gap');
      state.viewport.scrollLeft = 0;

      root.style.removeProperty('--tg-native-gap');
      root.style.removeProperty('--tg-native-slide-width');
      root.classList.remove('is-native-slider-ready');
      root.removeAttribute('data-native-slider-mode');

      states.delete(root);
    }

    function initSection(root) {
      if (!root) return;

      const mode = getMode(root);
      const existing = states.get(root);

      if (!mode) {
        destroySection(root);
        return;
      }

      if (existing?.mode === mode) {
        calculateLayout(existing, true);
        return;
      }

      if (existing) destroySection(root);

      const elements = getElements(root, mode);

      if (!elements.viewport || !elements.track || elements.slides.length < 2) {
        return;
      }

      const state = {
        root,
        mode,
        ...elements,
        currentIndex: 0,
        maxIndex: 0,
        step: 0,
        paginationButtons: [],
        cleanup: [],
        scrollFrame: 0,
        layoutFrame: 0,
        resizeObserver: null,
        autoplayTimer: 0,
        isInteracting: false,
      };

      const requestControlUpdate = () => {
        window.cancelAnimationFrame(state.scrollFrame);
        state.scrollFrame = window.requestAnimationFrame(() => {
          updateControls(state);
        });
      };

      const requestLayout = () => {
        window.cancelAnimationFrame(state.layoutFrame);
        state.layoutFrame = window.requestAnimationFrame(() => {
          calculateLayout(state, true);
        });
      };

      const handlePrevious = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (!state.previous?.disabled) {
          scrollToIndex(state, getCurrentIndex(state) - 1, true);
          scheduleAutoplay(state);
        }
      };

      const handleNext = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (!state.next?.disabled) {
          scrollToIndex(state, getCurrentIndex(state) + 1, true);
          scheduleAutoplay(state);
        }
      };

      const handlePagination = (event) => {
        const button = event.target.closest('[data-slider-index]');
        if (!button || !state.pagination?.contains(button)) return;

        event.preventDefault();
        scrollToIndex(
          state,
          Number.parseInt(button.dataset.sliderIndex || '0', 10),
          true
        );
        scheduleAutoplay(state);
      };

      const handleKeyboard = (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          scrollToIndex(state, getCurrentIndex(state) - 1, true);
          scheduleAutoplay(state);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          scrollToIndex(state, getCurrentIndex(state) + 1, true);
          scheduleAutoplay(state);
        }
      };

      const handleInteractionStart = () => {
        state.isInteracting = true;
        stopAutoplay(state);
      };

      const handleInteractionEnd = () => {
        state.isInteracting = false;
        scheduleAutoplay(state);
      };

      const handleMouseEnter = () => {
        if (state.root.dataset.pauseAutoplayHover !== 'true') return;

        state.isInteracting = true;
        stopAutoplay(state);
      };

      const handleMouseLeave = () => {
        if (state.root.dataset.pauseAutoplayHover !== 'true') return;

        state.isInteracting = false;
        scheduleAutoplay(state);
      };

      const handleVisibilityChange = () => {
        if (document.hidden) {
          stopAutoplay(state);
        } else {
          scheduleAutoplay(state);
        }
      };

      state.previous?.addEventListener('click', handlePrevious, true);
      state.next?.addEventListener('click', handleNext, true);
      state.pagination?.addEventListener('click', handlePagination);
      state.viewport.addEventListener('scroll', requestControlUpdate, { passive: true });
      state.viewport.addEventListener('keydown', handleKeyboard);
      state.viewport.addEventListener('pointerdown', handleInteractionStart, {
        passive: true,
      });
      window.addEventListener('pointerup', handleInteractionEnd, {
        passive: true,
      });
      window.addEventListener('pointercancel', handleInteractionEnd, {
        passive: true,
      });
      state.viewport.addEventListener('mouseenter', handleMouseEnter);
      state.viewport.addEventListener('mouseleave', handleMouseLeave);
      state.viewport.addEventListener('focusin', handleInteractionStart);
      state.viewport.addEventListener('focusout', handleInteractionEnd);
      document.addEventListener('visibilitychange', handleVisibilityChange);

      state.cleanup.push(
        () => state.previous?.removeEventListener('click', handlePrevious, true),
        () => state.next?.removeEventListener('click', handleNext, true),
        () => state.pagination?.removeEventListener('click', handlePagination),
        () => state.viewport.removeEventListener('scroll', requestControlUpdate),
        () => state.viewport.removeEventListener('keydown', handleKeyboard),
        () => state.viewport.removeEventListener('pointerdown', handleInteractionStart),
        () => window.removeEventListener('pointerup', handleInteractionEnd),
        () => window.removeEventListener('pointercancel', handleInteractionEnd),
        () => state.viewport.removeEventListener('mouseenter', handleMouseEnter),
        () => state.viewport.removeEventListener('mouseleave', handleMouseLeave),
        () => state.viewport.removeEventListener('focusin', handleInteractionStart),
        () => state.viewport.removeEventListener('focusout', handleInteractionEnd),
        () => document.removeEventListener('visibilitychange', handleVisibilityChange)
      );

      state.viewport.tabIndex = 0;
      state.viewport.setAttribute('role', 'region');
      state.viewport.setAttribute('aria-roledescription', 'carousel');

      if ('ResizeObserver' in window) {
        state.resizeObserver = new ResizeObserver(requestLayout);
        state.resizeObserver.observe(state.viewport);
      } else {
        window.addEventListener('resize', requestLayout, { passive: true });
        state.cleanup.push(() => window.removeEventListener('resize', requestLayout));
      }

      states.set(root, state);
      root.classList.add('is-native-slider-ready');
      root.dataset.nativeSliderMode = mode;

      calculateLayout(state, false);
    }

    function refreshAll(scope = document) {
      const roots = [];

      if (scope.matches?.(ROOT_SELECTOR)) roots.push(scope);
      scope.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => roots.push(root));

      roots.forEach(initSection);
    }

    function handleBreakpointChange() {
      refreshAll();
    }

    if (!window[MODULE_KEY]) {
      window[MODULE_KEY] = true;

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => refreshAll(), { once: true });
      } else {
        refreshAll();
      }

      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', handleBreakpointChange);
        desktopQuery.addEventListener('change', handleBreakpointChange);
      } else {
        mobileQuery.addListener(handleBreakpointChange);
        desktopQuery.addListener(handleBreakpointChange);
      }

      document.addEventListener('shopify:section:load', (event) => {
        refreshAll(event.target);
      });

      document.addEventListener('shopify:section:unload', (event) => {
        const root = event.target.matches?.(ROOT_SELECTOR)
          ? event.target
          : event.target.querySelector?.(ROOT_SELECTOR);

        if (root) destroySection(root);
      });

      document.addEventListener('shopify:block:select', (event) => {
        const root = event.target.closest?.(ROOT_SELECTOR);
        const slide = event.target.closest?.('.training-goals__slide');
        const state = root ? states.get(root) : null;

        if (!state || !slide) return;

        const index = state.slides.indexOf(slide);
        if (index >= 0) scrollToIndex(state, index, true);
      });
    } else {
      refreshAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cricket-programs-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const MODULE_KEY = 'CricketProgramsShowcaseModule';
    const SECTION_SELECTOR = '[data-cricket-programs]';
    const CARD_SELECTOR = '[data-cricket-program-card]';
    const instances = new WeakMap();

    function setActiveCard(root, activeCard) {
      root.querySelectorAll(CARD_SELECTOR).forEach((card) => {
        card.classList.toggle('is-active', card === activeCard);
      });
    }

    function initSection(root) {
      if (!root || instances.has(root)) return;

      const cards = Array.from(root.querySelectorAll(CARD_SELECTOR));
      if (!cards.length) return;

      const cleanup = [];
      const mobileQuery = window.matchMedia('(max-width: 989px)');

      const handleClick = (event) => {
        if (!mobileQuery.matches) return;

        const card = event.target.closest(CARD_SELECTOR);
        if (!card || !root.contains(card)) return;

        if (event.target.closest('a, button, input, select, textarea')) return;
        setActiveCard(root, card);
      };

      const handleFocus = (event) => {
        const card = event.target.closest(CARD_SELECTOR);
        if (card && root.contains(card)) setActiveCard(root, card);
      };

      root.addEventListener('click', handleClick);
      root.addEventListener('focusin', handleFocus);

      cleanup.push(() => root.removeEventListener('click', handleClick));
      cleanup.push(() => root.removeEventListener('focusin', handleFocus));

      let observer = null;

      const createObserver = () => {
        observer?.disconnect();
        observer = null;

        if (!mobileQuery.matches || !('IntersectionObserver' in window)) {
          cards.forEach((card) => card.classList.remove('is-active'));
          return;
        }

        observer = new IntersectionObserver(
          (entries) => {
            const visible = entries
              .filter((entry) => entry.isIntersecting)
              .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

            if (visible[0]) setActiveCard(root, visible[0].target);
          },
          {
            root: null,
            rootMargin: '-28% 0px -42% 0px',
            threshold: [0.2, 0.45, 0.7],
          }
        );

        cards.forEach((card) => observer.observe(card));
        setActiveCard(root, cards[0]);
      };

      const handleBreakpoint = () => createObserver();

      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', handleBreakpoint);
        cleanup.push(() => mobileQuery.removeEventListener('change', handleBreakpoint));
      } else {
        mobileQuery.addListener(handleBreakpoint);
        cleanup.push(() => mobileQuery.removeListener(handleBreakpoint));
      }

      createObserver();
      cleanup.push(() => observer?.disconnect());

      instances.set(root, () => cleanup.forEach((fn) => fn()));
    }

    function destroySection(root) {
      const destroy = instances.get(root);
      if (destroy) destroy();
      instances.delete(root);
    }

    function initAll(scope = document) {
      if (scope.matches?.(SECTION_SELECTOR)) initSection(scope);
      scope.querySelectorAll?.(SECTION_SELECTOR).forEach(initSection);
    }

    if (!window[MODULE_KEY]) {
      window[MODULE_KEY] = true;

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
      } else {
        initAll();
      }

      document.addEventListener('shopify:section:load', (event) => initAll(event.target));
      document.addEventListener('shopify:section:unload', (event) => {
        const root = event.target.matches?.(SECTION_SELECTOR)
          ? event.target
          : event.target.querySelector?.(SECTION_SELECTOR);

        if (root) destroySection(root);
      });
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-old"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-js-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeroSliders(scope) {
      if (!window.Swiper) return;

      const root = scope || document;
      const sliders = root.querySelectorAll('[data-hero-slider]');

      sliders.forEach(function (slider) {
        if (slider.dataset.heroInitialized === 'true') return;

        if (slider.dataset.slideLinksBound !== 'true') {
          slider.dataset.slideLinksBound = 'true';

          slider.addEventListener('click', function (event) {
            const slide = event.target.closest('.swiper-slide[data-slide-link]');
            if (!slide || !slider.contains(slide)) return;

            if (
              event.target.closest(
                'a, button, .swiper-pagination, .swiper-button-prev, .swiper-button-next'
              )
            ) {
              return;
            }

            if (slider.swiper && slider.swiper.allowClick === false) return;

            window.location.href = slide.dataset.slideLink;
          });

          slider.addEventListener('keydown', function (event) {
            if (event.key !== 'Enter' && event.key !== ' ') return;

            const slide = event.target.closest('.swiper-slide[data-slide-link]');
            if (!slide || !slider.contains(slide)) return;

            event.preventDefault();
            window.location.href = slide.dataset.slideLink;
          });
        }

        const slides = slider.querySelectorAll('.swiper-slide');
        const hasMultipleSlides = slides.length > 1;

        if (!hasMultipleSlides) {
          slider.classList.add('is-single-slide');
          return;
        }

        slider.dataset.heroInitialized = 'true';

        new Swiper(slider, {
          loop: true,
          speed: 700,
          effect: 'slide',
          grabCursor: true,
          watchOverflow: true,
          observer: true,
          observeParents: true,

          autoplay: {
            delay: 11115500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },

          pagination: {
            el: slider.querySelector('.swiper-pagination'),
            clickable: true,
          },

          navigation: {
            nextEl: slider.querySelector('.swiper-button-next'),
            prevEl: slider.querySelector('.swiper-button-prev'),
          },
        });
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      initHeroSliders(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      initHeroSliders(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
        if (slider.swiper) {
          slider.swiper.destroy(true, true);
          slider.dataset.heroInitialized = 'false';
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["infinite-partner-logo-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const tagName = 'infinite-logo-marquee';

    if (customElements.get(tagName)) return;

    class InfiniteLogoMarquee extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-marquee-viewport]');
        this.track = this.querySelector('[data-marquee-track]');
        this.source = this.querySelector('[data-marquee-source]');

        if (!this.viewport || !this.track || !this.source) return;

        this.originalItems = Array.from(
          this.source.querySelectorAll(':scope > [data-marquee-item]')
        ).map((item) => item.cloneNode(true));

        if (!this.originalItems.length) return;

        this.lastWidth = 0;
        this.build();

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver((entries) => {
            const width = Math.round(entries[0]?.contentRect?.width || 0);

            if (!width || Math.abs(width - this.lastWidth) < 2) return;

            this.lastWidth = width;
            window.cancelAnimationFrame(this.rebuildFrame);

            this.rebuildFrame = window.requestAnimationFrame(() => {
              this.build();
            });
          });

          this.resizeObserver.observe(this.viewport);
        }
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        window.cancelAnimationFrame(this.rebuildFrame);
      }

      cloneItem(item, duplicate) {
        const clone = item.cloneNode(true);

        if (duplicate) {
          clone.setAttribute('aria-hidden', 'true');

          clone
            .querySelectorAll('a, button, input, select, textarea, [tabindex]')
            .forEach((element) => element.setAttribute('tabindex', '-1'));
        }

        return clone;
      }

      appendCycle(group, duplicate) {
        this.originalItems.forEach((item) => {
          group.appendChild(this.cloneItem(item, duplicate));
        });
      }

      build() {
        this.classList.remove('is-ready');
        this.track.style.animation = 'none';
        this.track.innerHTML = '';

        const source = document.createElement('div');
        source.className = 'partner-logo-marquee__group';
        source.dataset.marqueeSource = '';
        this.track.appendChild(source);

        /*
         * The first cycle stays accessible. Extra cycles are visual duplicates.
         */
        this.appendCycle(source, false);

        const viewportWidth = Math.ceil(this.viewport.getBoundingClientRect().width);
        const firstCycleWidth = Math.max(1, Math.ceil(source.getBoundingClientRect().width));
        const minimumWidth = Math.max(viewportWidth * 1.35, firstCycleWidth * 2);

        let repeatCount = 0;

        while (source.getBoundingClientRect().width < minimumWidth && repeatCount < 50) {
          this.appendCycle(source, true);
          repeatCount += 1;
        }

        const duplicate = source.cloneNode(true);
        duplicate.removeAttribute('data-marquee-source');
        duplicate.setAttribute('aria-hidden', 'true');

        duplicate
          .querySelectorAll('a, button, input, select, textarea, [tabindex]')
          .forEach((element) => element.setAttribute('tabindex', '-1'));

        this.track.appendChild(duplicate);

        const styles = window.getComputedStyle(this.track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
        const sourceWidth = Math.ceil(source.getBoundingClientRect().width);
        const distance = sourceWidth + gap;
        const speed = Math.max(20, Number.parseFloat(this.dataset.speed || '70'));
        const duration = Math.max(8, distance / speed);

        this.style.setProperty('--marquee-distance', `${distance}px`);
        this.style.setProperty('--marquee-duration', `${duration}s`);

        /*
         * Force layout before starting. This removes the initial jump/blink.
         */
        this.track.getBoundingClientRect();
        this.track.style.removeProperty('animation');

        window.requestAnimationFrame(() => {
          this.classList.add('is-ready');
        });
      }
    }

    customElements.define(tagName, InfiniteLogoMarquee);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hotspot-image"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ELEMENT_NAME = 'hotspot-product-showcase';

    if (customElements.get(ELEMENT_NAME)) return;

    class HotspotProductShowcase extends HTMLElement {
      constructor() {
        super();

        this.activeCard = null;
        this.activeTrigger = null;
        this.media = null;
        this.image = null;
        this.resizeObserver = null;
        this.layoutFrame = null;
        this.mobileQuery = window.matchMedia('(max-width: 749px)');

        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.scheduleLayout = this.scheduleLayout.bind(this);
      }

      connectedCallback() {
        this.media = this.querySelector('.hotspot-shop__media');
        this.image = this.querySelector('.hotspot-shop__image');

        this.addEventListener('click', this.handleClick);
        this.addEventListener('change', this.handleChange);
        this.addEventListener('submit', this.handleSubmit);
        document.addEventListener('keydown', this.handleKeydown);
        document.addEventListener('click', this.handleDocumentClick);
        window.addEventListener('resize', this.scheduleLayout, { passive: true });
        this.image?.addEventListener('load', this.scheduleLayout);

        if (this.mobileQuery.addEventListener) {
          this.mobileQuery.addEventListener('change', this.scheduleLayout);
        } else {
          this.mobileQuery.addListener(this.scheduleLayout);
        }

        if ('ResizeObserver' in window && this.media) {
          this.resizeObserver = new ResizeObserver(this.scheduleLayout);
          this.resizeObserver.observe(this.media);
        }

        this.scheduleLayout();

        if (document.fonts?.ready) {
          document.fonts.ready.then(this.scheduleLayout).catch(() => {});
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('change', this.handleChange);
        this.removeEventListener('submit', this.handleSubmit);
        document.removeEventListener('keydown', this.handleKeydown);
        document.removeEventListener('click', this.handleDocumentClick);
        window.removeEventListener('resize', this.scheduleLayout);
        this.image?.removeEventListener('load', this.scheduleLayout);

        if (this.mobileQuery.removeEventListener) {
          this.mobileQuery.removeEventListener('change', this.scheduleLayout);
        } else {
          this.mobileQuery.removeListener(this.scheduleLayout);
        }

        this.resizeObserver?.disconnect();
        window.cancelAnimationFrame(this.layoutFrame);
      }

      clamp(value, minimum, maximum) {
        return Math.min(Math.max(value, minimum), maximum);
      }

      scheduleLayout() {
        window.cancelAnimationFrame(this.layoutFrame);

        this.layoutFrame = window.requestAnimationFrame(() => {
          this.updateHotspotPositions();

          if (this.activeCard && this.activeTrigger) {
            this.positionCard(this.activeTrigger, this.activeCard);
          }
        });
      }

      /**
       * The Theme Editor values represent coordinates on the original image,
       * not on the cropped container. This conversion keeps every hotspot
       * attached to the same object while object-fit: cover changes its crop.
       */
      updateHotspotPositions() {
        if (!this.media) return;

        const image = this.image;
        const mediaWidth = this.media.clientWidth;
        const mediaHeight = this.media.clientHeight;

        if (!image || !image.naturalWidth || !image.naturalHeight || !mediaWidth || !mediaHeight) {
          return;
        }

        const scale = Math.max(
          mediaWidth / image.naturalWidth,
          mediaHeight / image.naturalHeight
        );

        const renderedWidth = image.naturalWidth * scale;
        const renderedHeight = image.naturalHeight * scale;
        const cropOffsetX = (mediaWidth - renderedWidth) / 2;
        const cropOffsetY = (mediaHeight - renderedHeight) / 2;
        const useMobile = this.mobileQuery.matches;

        this.querySelectorAll('[data-hotspot-point]').forEach((point) => {
          const hasMobilePosition =
            useMobile && point.dataset.mobileCustom === 'true';

          const x = Number.parseFloat(
            hasMobilePosition ? point.dataset.mobileX : point.dataset.desktopX
          );

          const y = Number.parseFloat(
            hasMobilePosition ? point.dataset.mobileY : point.dataset.desktopY
          );

          if (!Number.isFinite(x) || !Number.isFinite(y)) return;

          const renderedX = cropOffsetX + renderedWidth * (x / 100);
          const renderedY = cropOffsetY + renderedHeight * (y / 100);

          point.style.setProperty('--hs-render-x', `${renderedX}px`);
          point.style.setProperty('--hs-render-y', `${renderedY}px`);
        });
      }

      handleClick(event) {
        const trigger = event.target.closest('[data-hotspot-trigger]');

        if (trigger && this.contains(trigger)) {
          event.preventDefault();

          const cardId = trigger.getAttribute('aria-controls');
          const card = cardId
            ? this.querySelector(`#${CSS.escape(cardId)}`)
            : null;

          if (!card) return;

          if (this.activeCard === card) {
            this.closeCard();
          } else {
            this.openCard(trigger, card);
          }

          return;
        }

        if (event.target.closest('[data-hotspot-close]')) {
          event.preventDefault();
          this.closeCard();
          return;
        }

        if (event.target.matches('[data-hotspot-backdrop]')) {
          this.closeCard();
        }
      }

      handleDocumentClick(event) {
        if (!this.activeCard || this.contains(event.target)) return;
        this.closeCard();
      }

      handleKeydown(event) {
        if (event.key === 'Escape' && this.activeCard) {
          this.closeCard();
        }
      }

      openCard(trigger, card) {
        this.closeCard(false);

        card.hidden = false;
        card.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');

        this.activeCard = card;
        this.activeTrigger = trigger;
        this.classList.add('is-card-open');

        window.requestAnimationFrame(() => {
          this.updateHotspotPositions();
          this.positionCard(trigger, card);

          window.requestAnimationFrame(() => {
            this.positionCard(trigger, card);
            card.querySelector('[data-hotspot-close]')?.focus();
          });
        });
      }

      /**
       * Desktop card placement follows the hotspot but is clamped inside the
       * image area. A low or high hotspot therefore never pushes the card out
       * of the visible section. Mobile keeps the fixed bottom-sheet layout.
       */
      positionCard(trigger, card) {
        if (!this.media || !trigger || !card) return;

        if (this.mobileQuery.matches) {
          card.style.removeProperty('--hs-card-top');
          card.style.removeProperty('max-height');
          card.style.removeProperty('overflow-y');
          return;
        }

        const point = trigger.closest('[data-hotspot-point]');
        if (!point) return;

        const mediaRect = this.media.getBoundingClientRect();
        const triggerRect = trigger.getBoundingClientRect();
        const triggerCenterX = triggerRect.left + triggerRect.width / 2;
        const triggerCenterY = triggerRect.top + triggerRect.height / 2;
        const edgeGap = 12;
        const cardGap = 14;
        const availableHeight = Math.max(220, mediaRect.height - edgeGap * 2);

        card.style.maxHeight = `${availableHeight}px`;
        card.style.overflowY = 'auto';

        let cardRect = card.getBoundingClientRect();
        const rightSpace = mediaRect.right - triggerCenterX - cardGap;
        const leftSpace = triggerCenterX - mediaRect.left - cardGap;
        const placeCardOnLeft =
          rightSpace < cardRect.width + cardGap && leftSpace > rightSpace;

        point.classList.toggle('hotspot-shop__point--align-right', placeCardOnLeft);

        cardRect = card.getBoundingClientRect();
        const cardHeight = Math.min(cardRect.height, availableHeight);
        const minimumTop = mediaRect.top + edgeGap;
        const maximumTop = Math.max(
          minimumTop,
          mediaRect.bottom - cardHeight - edgeGap
        );

        const desiredTop = triggerCenterY - cardHeight / 2;
        const clampedTop = this.clamp(desiredTop, minimumTop, maximumTop);
        const pointRect = point.getBoundingClientRect();

        card.style.setProperty(
          '--hs-card-top',
          `${clampedTop - pointRect.top}px`
        );
      }

      closeCard(restoreFocus = true) {
        if (!this.activeCard) return;

        this.activeCard.hidden = true;
        this.activeCard.setAttribute('aria-hidden', 'true');
        this.activeCard.style.removeProperty('--hs-card-top');
        this.activeCard.style.removeProperty('max-height');
        this.activeCard.style.removeProperty('overflow-y');
        this.activeTrigger?.setAttribute('aria-expanded', 'false');
        this.classList.remove('is-card-open');

        const trigger = this.activeTrigger;

        this.activeCard = null;
        this.activeTrigger = null;

        if (restoreFocus) {
          trigger?.focus();
        }
      }

      handleChange(event) {
        const select = event.target.closest('[data-hotspot-variant-select]');
        if (!select || !this.contains(select)) return;

        const card = select.closest('[data-hotspot-card]');
        const option = select.options[select.selectedIndex];
        if (!card || !option) return;

        const input = card.querySelector('[data-hotspot-variant-input]');
        const price = card.querySelector('[data-hotspot-price]');
        const compare = card.querySelector('[data-hotspot-compare-price]');
        const image = card.querySelector('.hotspot-shop__product-image');
        const button = card.querySelector('[data-hotspot-add-button]');
        const label = card.querySelector('[data-hotspot-button-label]');
        const available = option.dataset.available === 'true';

        if (input) input.value = option.value;
        if (price) price.textContent = option.dataset.price || '';

        if (compare) {
          compare.textContent = option.dataset.comparePrice || '';
          compare.hidden = !option.dataset.comparePrice;
        }

        if (image && option.dataset.image) {
          image.src = option.dataset.image;
          image.removeAttribute('srcset');
        }

        if (button) {
          button.disabled = !available;

          if (label) {
            label.textContent = available
              ? button.dataset.addLabel
              : button.dataset.soldOutLabel;
          }
        }

        this.scheduleLayout();
      }

      async handleSubmit(event) {
        const form = event.target.closest('[data-hotspot-product-form]');
        if (!form || !this.contains(form)) return;

        event.preventDefault();

        const button = form.querySelector('[data-hotspot-add-button]');
        const status = form.querySelector('[data-hotspot-status]');
        if (!button || button.disabled) return;

        button.disabled = true;
        button.classList.add('is-loading');

        if (status) {
          status.textContent = '';
          status.classList.remove('is-error');
        }

        const formData = new FormData(form);
        const cart =
          document.querySelector('cart-drawer') ||
          document.querySelector('cart-notification');

        if (cart?.getSectionsToRender) {
          const ids = cart
            .getSectionsToRender()
            .map((section) => section.id)
            .filter(Boolean);

          if (ids.length) {
            formData.append('sections', ids.join(','));
            formData.append('sections_url', window.location.pathname);
          }
        }

        try {
          const response = await fetch(
            window.routes?.cart_add_url || '/cart/add.js',
            {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: formData,
            }
          );

          const result = await response.json();

          if (!response.ok || result.status) {
            throw new Error(
              result.description ||
                result.message ||
                'Unable to add this product to the cart.'
            );
          }

          if (cart?.renderContents) {
            cart.renderContents(result);
          } else {
            document.dispatchEvent(
              new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: {
                  source: 'hotspot-product-showcase',
                  item: result,
                },
              })
            );
          }

          if (status) {
            status.textContent = button.dataset.addLabel;
          }

          this.dispatchEvent(
            new CustomEvent('hotspot:product-added', {
              bubbles: true,
              detail: { item: result },
            })
          );
        } catch (error) {
          if (status) {
            status.textContent = error.message;
            status.classList.add('is-error');
          }
        } finally {
          button.classList.remove('is-loading');
          button.disabled = false;
          this.scheduleLayout();
        }
      }
    }

    customElements.define(ELEMENT_NAME, HotspotProductShowcase);
  })();

  } catch(e) { console.error(e); }
})();
})();
